import React, { Fragment, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import BodyClassName from 'react-body-classname';
import Modal from 'components/Modal';
import './style.scss';

const LoanCardTooltip = (props) => {
  const [isActive, setIsActive] = useState(false);
  const toolTipRef = useRef(null);

  const handleClickOutside = (event) => {
    if (toolTipRef.current && !toolTipRef.current.contains(event.target)) {
      setIsActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleTrigger = () => {
    const currentState = isActive;
    setIsActive(!currentState);
  };

  const { offset, className, children } = props;
  return (
    <>
      <div
        className={`loanCard-tooltip tooltip ${offset !== 0 ? `offset${offset}` : ''} ${isActive ? 'active' : ''}`}
        ref={toolTipRef}
      >
        <div
          className="trigger"
          onClick={handleTrigger}
        />
      </div>
      {
        isActive
          && (
          <BodyClassName className="overflowHidden">
            <Modal className={className}>
              <div className="card-header">
                <h5>{props.title}</h5>
              </div>
              <div className="close" onClick={handleTrigger} />
              <div className="card-content security-error">
                {children}
              </div>
            </Modal>
          </BodyClassName>
          )
      }
    </>
  );
};

LoanCardTooltip.propTypes = {
  offset: PropTypes.number,
  className: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
};

LoanCardTooltip.defaultProps = {
  offset: 0,
  className: '',
  title: '',
};

export default LoanCardTooltip;
